import React from 'react';
import { Container } from 'components/UI/Container/Container';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { WistiaVideo } from 'components/UI/WistiaVideo';
import { YoutubeVideo } from 'components/UI/YoutubeVideo';
import './VideoPlayer.scss';
import { SupportedPrismicSlicesEnum } from '../enums';

export enum VideoApiEnum {
    Wistia = 'Wistia',
    Youtube = 'Youtube',
}

type VideoPlayerProps = {
    slice: {
        type: SupportedPrismicSlicesEnum.videoplayer;
        primary: {
            video_id: string;
            size: 'fullscreen' | 'bordered';
            video_api: VideoApiEnum;
        };
    };
};

enum VideoplayerSizeToContainerSizeMapping {
    fullscreen = 'full',
    bordered = 'xs',
}

class VideoPlayer extends React.Component<VideoPlayerProps> {
    render() {
        return (
            <Container size={VideoplayerSizeToContainerSizeMapping[this.props.slice.primary.size]}>
                <Grid>
                    <GridRow horizontalAlign={'h-center'} verticalAlign={'v-center'}>
                        <GridCol colSize={`12`} className="Video-container">
                            {this.props.slice.primary.video_api === VideoApiEnum.Wistia ? (
                                <WistiaVideo videoId={this.props.slice.primary.video_id} autoplay={false} />
                            ) : (
                                <YoutubeVideo videoId={this.props.slice.primary.video_id} autoplay={false} />
                            )}
                        </GridCol>
                    </GridRow>
                </Grid>
            </Container>
        );
    }
}

export { VideoPlayer, VideoPlayerProps };
